import BaseComponent from 'foundation/base-component';
import { tns } from 'tiny-slider/src/tiny-slider';
import eventBus from 'general/js/event-bus';

const MOBILE_BREAKPOINT = 1023;

const SUBLAYOUT_FULLWIDTH_ENABLE = 'SUBLAYOUT_FULLWIDTH_ENABLE';
const SUBLAYOUT_FULLWIDTH_DISABLE = 'SUBLAYOUT_FULLWIDTH_DISABLE';

class SublayoutComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.slider = null;
        this.handleResize = this.handleResize.bind(this);

        this.init();
    }

    init() {
        eventBus.addListener(SUBLAYOUT_FULLWIDTH_ENABLE, this.enableFullwidth);
        eventBus.addListener(SUBLAYOUT_FULLWIDTH_DISABLE, this.disableFullwidth);

        this.toggleMobileSlider();
        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.toggleMobileSlider();
    }

    toggleMobileSlider() {
        if (!this.element.classList.contains('sublayout--slide')) {
            return;
        }

        const grid = this.element.querySelector('.sublayout__grid');
        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

        if (isMobile) {
            if (!this.slider && grid) {
                this.slider = tns({
                    container: grid,
                    items: 1,
                    slideBy: 1,
                    gutter: 0,
                    nav: true,
                    navPosition: 'bottom',
                    controls: false,
                    mouseDrag: true,
                    swipeAngle: false,
                    loop: false,
                });
            }
        } else {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
        }
    }

    onDestroy() {
        eventBus.removeListener(SUBLAYOUT_FULLWIDTH_ENABLE, this.enableFullwidth);
        eventBus.removeListener(SUBLAYOUT_FULLWIDTH_DISABLE, this.disableFullwidth);

        window.removeEventListener('resize', this.handleResize);
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    enableFullwidth = () => {
        this.element.classList.add('is-fullwidth');
    }

    disableFullwidth = () => {
        this.element.classList.remove('is-fullwidth');
    }
}

export default SublayoutComponent;
